import { createFileRoute, Outlet } from '@tanstack/react-router';
import { privateCacheHeaders } from '@/analytics/cache-headers';
import { useKeepAuthSessionSubscribed } from '@/services/auth-service';

export const Route = createFileRoute('/app')({
  // Every `/app/*` page server-renders the signed-in user's data, and the CDN's
  // cache key carries no cookies, so no response here may ever be shared.
  headers: privateCacheHeaders(),
  component: Page,
});

function Page() {
  // Declared on the `/app` layout, the one component mounted across the whole
  // subtree — including the `_authenticated` -> `(auth)` transition a logout
  // performs, which is where the store used to go dormant. See the hook.
  useKeepAuthSessionSubscribed();

  return (
    <div
      id='app'
      className='relative h-dvh w-full overflow-hidden bg-violet-500 dark:bg-navy-760'
    >
      <Outlet />
    </div>
  );
}
